import Dropzone from "dropzone";
import goals from "../utils/goals";
import UIComponent from "../ui/component";
import api from "../api";

export class UploadForm extends UIComponent {
    maxFiles = 100;
    hasShownModalForDrag = false;

    init() {
        this.includeComponents({ uploadModal: "document@#upload-modal" });
        this.files = [];
        this.hasShownModalForDrag = false;

        if (!Number(this.available_region)) {
            this.includeComponents({
                regionPaymentModal: "document@#regionPaymentModal",
            });
        }

        this.initDropzone();

        if (this.uploadByLink) {
            this.uploadByLink.onSuccess = (files) => {
                goals.reach("linkImportSuccess");
                if (files && files.transcription_id) {
                    files._isLinkFile = true;
                }
                this.updatePreviewFiles([files]);
            };
            this.uploadByLink.onError = (errors) => {
                goals.reach("linkImportFailed");
                this.uploadByLink?.notification.hide();
                const link = this.uploadByLink.link?.element?.value;
                const errorFile = {
                    transcription_id: -Date.now(),
                    name: link || "Link file",
                };

                this.updatePreviewFiles([errorFile]);

                const file = this.dropzone.files.find(
                    (f) => f.transcription_id == errorFile.transcription_id
                );
                if (file) {
                    file.icon = window.app.icons.error;
                    file.error =  errors?.throwable_error;
                    file.status = "error";

                    this.updateFilePreview(file);

                    if (file.previewElement) {
                        const row = file.previewElement;
                        row.querySelector(".progress")?.remove();
                        const icon = row.querySelector(".js-preview-icon");
                        if (icon)
                            icon.setAttribute("src", window.app.icons.error);
                        const errorEl = row.querySelector(".js-file-error");
                        if (errorEl) {
                            errorEl.classList.remove("d-none");
                            errorEl.textContent =  errors?.throwable_error;
                        }
                        const duration = row.querySelector(".js-duration");
                        if (duration) duration.classList.add("d-none");
                    }
                }
            };
        }
        this.loadUnpaidTranscriptions();
        setTimeout(this.updateDraftFiles.bind(this), 3000);
    }

    initDropzone() {
        let previewTemplate = this.previewTemplateContainer
            .removeClass("d-none")
            .html();
        this.previewTemplateContainer.remove();
        this.dropzone = new Dropzone(document.body, {
            url: this.dropzoneForm.attr("action"),
            createImageThumbnails: false,
            headers: {
                "X-Folder-Id": this.dropzoneForm.folderid,
            },

            maxFiles: this.maxFiles,
            maxFilesize: 8192,
            previewTemplate: previewTemplate,
            chunking: true,
            forceChunking: true,
            chunkSize: 50000000,
            // Без явного timeout Dropzone берёт дефолт 30 000 мс на КАЖДЫЙ чанк (50 МБ):
            // на больших видео и небыстром аплинке чанк не успевает → таймаут → загрузка
            // падает, не доходя до «Transcribe». Даём 10 мин на чанк и ретраим сбойные.
            timeout: 600000,
            retryChunks: true,
            retryChunksLimit: 3,
            autoQueue: true,
            previewsContainer: this.previewContainer.el(),
            clickable: [".fileinput-button", ".js-upload-icon"],
            
        });
        this.dropzone.on("dragenter", this.handleDragEnter.bind(this));
        this.dropzone.on("dragleave", this.handleDragLeave.bind(this));
        this.dropzone.on("drop", this.handleDrop.bind(this));
        this.dropzone.on("addedfile", this.onAddFile.bind(this));
        // Цель «Начал загрузку файлика» (Метрика): срабатывает, когда файл РЕАЛЬНО
        // начал заливаться на сервер (processing). Инжект уже загруженных неоплаченных
        // файлов на старте страницы (loadUnpaidTranscriptions → injectFile) этот ивент
        // не триггерит — поэтому ложных срабатываний, из-за которых цель отключали, нет.
        this.dropzone.on("processing", this.onProcessingFile.bind(this));
        this.dropzone.on("error", this.onErrorFile.bind(this));
        this.dropzone.on("complete", this.onFileComplete.bind(this));
        this.dropzone.on("removedfile", this.onRemoveFile.bind(this));
    }

    updateDraftFiles() {
        if (this.hasDownloadingFiles()) {
            this.loadUnpaidTranscriptions();
        }

        setTimeout(this.updateDraftFiles.bind(this), 3000);
    }

    handleDragEnter(e) {
        if (e.target.closest("#upload-modal")) {
            return;
        }
        this.hasShownModalForDrag = true;
    }

    handleDragLeave(e) {
        if (e.relatedTarget && e.relatedTarget.closest("#upload-modal")) {
            return;
        }

        if (e.clientX === 0 && e.clientY === 0) {
            this.hasShownModalForDrag = false;
        }
    }

    handleDrop(e) {
        if (e.dataTransfer?.items?.length > this.maxFiles) {
            return false;
        }

        if (!this.uploadModal?.element.classList.contains("show")) {
            this.uploadModal?.show();
        }
        this.hasShownModalForDrag = false;
        return true;
    }

    onAddFile(file) {
        if (file.size === 0) {
            this.dropzone.removeFile(file);
            return;
        }

        // Цель startFileUpload перенесена на событие "processing" (реальный старт загрузки):
        // в onAddFile файл добавляется и при инжекте уже загруженных неоплаченных файлов,
        // что давало ложные срабатывания.
        this.checkout.hide();
    }

    onProcessingFile() {
        goals.reach("startFileUpload");
    }

    updatePreviewFiles(files) {
        let injectedNewFile = false;
        files.forEach((file) => {
            if (this.injectFile(file)) {
                injectedNewFile = true;
            }
        });

        setTimeout(() => {
            this.onFilesChanged();
        }, 100);
    }

    async loadUnpaidTranscriptions() {
        const response = await api.get("/api/files/unpaid");
        const hasDownloadingFiles = response.some(
            (file) => file.status === "downloading"
        );

        if (hasDownloadingFiles) {
            this.uploadByLink?.notification.show();
        }

        this.updatePreviewFiles(response);
    }

    onErrorFile(file, error, xhr) {
        //@todo: вместо удаления файла, нужно отметить как файл с ошибкой
        //this.dropzone.removeFile(file);
        let row = file.previewElement;
        let errorMessage = '';

        if (
            ["Upload canceled.", "You can not upload any more files."].includes(
                error
            )
        ) {
            return;
        }

        if (!xhr || xhr.status === 0) {
            errorMessage =
                window.app.translation[window.app.currentLocale]['errors.connection_refused'];
            this.buildErrorRow(row, errorMessage);
        }

        //TODO: нужен вывод остальных строчных ошибок
        if (typeof error === "string" && error.indexOf("Max filesize") !== -1) {
            if (this.isPromoForm) {
                this.dropzone.removeFile(file);
                this.errorBag.show(
                    window.app.translation[window.app.currentLocale][
                        "validation.media.file_size"
                    ],
                    true
                );
            }

            errorMessage =
                window.app.translation[window.app.currentLocale][
                    "validation.media.file_size"
                ];
            this.buildErrorRow(row, errorMessage);
        }

        if (error.data) {
            errorMessage = error.status.message ? error.status.message : error.data.errors.throwable_error ;

            if (this.isPromoForm) {
                this.dropzone.removeFile(file);
                this.errorBag.show(errorMessage);
            } else {
                this.buildErrorRow(row, errorMessage);
            }
        }
    }

    markUploadFailed(file) {
        const errorMessage =
            window.app.translation[window.app.currentLocale]["exceptions.files.upload_interrupted"];

        file.status = "error";
        file.error = errorMessage;

        if (this.isPromoForm) {
            this.dropzone.removeFile(file);
            this.errorBag.show(errorMessage);
        } else {
            this.buildErrorRow(file.previewElement, errorMessage);
        }

        setTimeout(() => {
            this.onFilesChanged();
        }, 150);
    }

    /** Оставляем ошибку в виде загруженного файла */
    buildErrorRow(row, errorMessage) {
        row.querySelector(".progress")?.remove();
        row.querySelector(".js-duration")?.remove();
        row.querySelector(".js-preview-icon")?.setAttribute(
            "src",
            window.app.icons.error
        );
        row.querySelector(".js-file-error").classList?.remove("d-none");
        row.querySelector(".js-file-error").textContent = errorMessage;
    }

    /**
     * Срабатывает когда дропзона доставила файл на сервер
     *
     * Формат атрибута file - специфический, от Dropzone.js
     *
     * @param {*} file
     * @returns
     */
    onFileComplete(file) {
        if (!file || file.status === "error") {
            return;
        }

        try {
            let transcriptionId = file.transcription_id || file.id;
            let duration = file.duration;
            let row = file.previewElement;
            let icon = file.icon;

            if (file.xhr) {
                let data = JSON.parse(file.xhr.response)?.data?.[0];
                if (!data?.transcription_id) {
                    // Сервер не вернул загруженный файл (например, ответ на повтор чанка
                    // вида {"done": 9}). Без этой проверки файл выглядел загруженным, а на
                    // «Транскрибировать» уходил пустой список → errors.batch.no_files (A2T-53).
                    this.markUploadFailed(file);
                    return;
                }
                if (data.error) {
                    if (this.isPromoForm) {
                        this.errorBag.show(data.error);

                        this.dropzone.removeFile(file);
                        return;
                    } else {
                        file.error = data.error;
                    }
                }

                if (data.duration) duration = data.duration;
                if (data.icon) icon = data.icon;
                transcriptionId = data.transcription_id;

                setTimeout(() => {
                    this.updateFilePreview(data);
                }, 100);
            }

            if (duration) {
                row.querySelector(".js-formupload-duration").innerHTML =
                    duration;
            }
            if (icon) {
                row.querySelector(".js-preview-icon").setAttribute(
                    "src",
                    icon
                );
            } else {
                row.querySelector(".js-preview-icon").setAttribute(
                    "src",
                    window.app.icons.default
                );
            }

            row.querySelector(".js-preview-field").setAttribute(
                "value",
                transcriptionId
            );
            row.querySelector(".progress").remove();

            file.transcription_id = transcriptionId;
        } catch (e) {
            console.error("Ошибка при загрузке файла", e);
            this.markUploadFailed(file);
            return;
        }

        setTimeout(() => {
            this.onFilesChanged();
        }, 150);
    }

    async onRemoveFile(file) {
        goals.reach("fileRemoved");

        if (file.status === "queued") {
            this.dropzone.cancelUpload(file);
        }

        if (file.transcription_id) {
            this.removeFileFromArray(file.transcription_id);
            this.deleteFile(file.transcription_id);
        }

        setTimeout(() => {
            this.onFilesChanged();
        }, 1);
    }

    removeFileFromArray(transcriptionId) {
        this.dropzone.files = this.dropzone.files.filter(
            (f) => f.transcription_id != transcriptionId
        );
    }

    onFilesChanged() {
        // Событие срабатывает если добавились файnsoлы и сейчас нет файлов в процессе загрузки

        if (
            this.dropzone.getQueuedFiles().length > 0 ||
            this.dropzone.getUploadingFiles().length > 0
        ) {
            return;
        }
        // console.log('onFilesChanged', this.dropzone.files.length, this.dropzone.files);
        const checksum = this.getFilesChecksum();
        // console.log('checksum', this.lastChangeChecksum, checksum);
        if (this.lastChangeChecksum == checksum) {
            return;
        }
        this.lastChangeChecksum = checksum;

        if (this.dropzone.files.length >= 1) {
            this.onFilesExists(this.dropzone.files.length);
        } else {
            this.onFilesEmpty();
        }
    }

    onFilesEmpty() {
        this.checkout.hide();
        this.dropzoneForm.show();
        this.uploadByLink?.show();
        this.dropzoneUpload.replaceClass("btn-secondary", "btn-primary");
    }

    onFilesExists(countFiles) {
        // Проверяем можно ли пересчитывать стоимость, все ли файлы для этого готовы
        if (!this.isAllFilesReady()) {
            this.checkout.hide();
            return;
        }

        this.checkout.show();
        this.checkout.update(this.getFiles());
        this.uploadByLink?.notification.hide();

        this.dropzoneUpload.replaceClass("btn-primary", "btn-secondary");

        if (countFiles >= this.maxFiles) {
            this.dropzoneForm.hide();
            this.uploadByLink?.hide();
        } else {
            this.dropzoneForm.show();
            this.uploadByLink?.show();
        }
    }

    hasDownloadingFiles() {
        const files = this.dropzone.files;
        for (let index in files) {
            var file = files[index];
            if (file.status == "downloading") {
                return true;
            }
        }
        return false;
    }

    isAllFilesReady() {
        const files = this.dropzone.files;
        if (!files || files.length === 0) {
            this.alertWarning.hide();
            return false;
        }
        let hasSuccess = false;
        let hasError = false;
        let hasPending = false;

        for (const file of files) {
            if (
                file.status === "downloading" ||
                file.status === "download_error" ||
                file.status === "error"
            ) {
                hasPending = true;
            }

            if (file.error) {
                hasError = true;
            } else {
                hasSuccess = true;
            }
        }
        if (hasPending) {
            this.alertWarning.hide();
            return false;
        }
        if (hasSuccess && hasError) {
            this.alertWarning.show();
        } else {
            this.alertWarning.hide();
        }
        return hasSuccess;
    }

    getFiles() {
        let files = [];
        const options = {};

        const lang = this.checkout?.s_language?.getValue();
        const speakersRaw = this.checkout?.s_speakers?.getValue();

        const language = this.parseOption(lang, "language", "auto");

        options.language = language;

        const speakers = this.parseOption(speakersRaw, "speakers", false);
        if (speakers !== false) {
            options.speakers = speakers;
        }

        // Собираем только валидные транскрипции для отправки на бек.
        // В UI в dropzone могут оставаться "плейсхолдеры" на ошибках (например transcription_id < 0)
        // и файлы в неподготовленных состояниях — их нельзя включать в запрос на transcribe.
        for (let index in this.dropzone.files) {
            const file = this.dropzone.files[index];

            const id = Number(file.transcription_id);
            if (!Number.isFinite(id) || id <= 0) continue;

            // Явно ошибочные/не готовые статусы исключаем.
            if (file.error) continue;
            if (
                file.status === "downloading" ||
                file.status === "download_error" ||
                file.status === "error"
            ) {
                continue;
            }

            files.push(id);
        }

        return {
            files: files,
            options: options,
        };
    }

    parseOption(value, optionName, defaultValue) {
        if (typeof value === "object" && value !== null) {
            const optionValue = value?.[`options[${optionName}]`];
            return optionValue !== undefined ? optionValue : defaultValue;
        }
        if (typeof value === "string") {
            return value || defaultValue;
        }
        return defaultValue;
    }

    stringToNumber(str) {
        if (!str) return 0;
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = (hash << 5) - hash + str.charCodeAt(i);
            hash |= 0; // Преобразуем в 32-битное целое
        }
        return Math.abs(hash);
    }

    getFilesChecksum() {
        const files = this.dropzone.files;
        const checksum = files.reduce((acc, file) => {
            // Мини функция для конвертации статуса файла в число через хеширование

            return (
                acc +
                Number(file.transcription_id || 0) +
                this.stringToNumber(file.status)
            );
        }, 0);
        return checksum;
    }

    addTranscription(transcription) {
        this.injectFile(transcription.toDataObject());
    }

    injectFile(mockFile) {
        if (this.isPromoForm) {
            this.uploadByLink?.hide();
        }

        const filePreview = mockFile.icon || window.app.icons.default;

        // Не добавляем файл если он уже есть в списке
        for (let index in this.dropzone.files) {
            var file = this.dropzone.files[index];
            if (file.transcription_id == mockFile.transcription_id) {
                setTimeout(() => {
                    this.updateFilePreview(mockFile);
                }, 100);
                this.dropzone.files[index] = mockFile;
                return;
            }
        }

        this.dropzone.files.push(mockFile);
        this.dropzone.displayExistingFile(mockFile, filePreview);
        setTimeout(() => {
            this.updateFilePreview(mockFile);
        }, 100);
        return true;
    }

    updateFilePreview(file) {
        // const row = file.previewElement;
        const previews = this.previewContainer.findAll(
            ".dz-image-preview, .dz-complete"
        );
        // Преобразуем в массив DOM элементов
        const previewElements = Array.from(previews);
        // console.log('updateFilePreview', file, previewElements, previews);
        for (let preview of previewElements) {
            var input = preview.querySelector('input[name="files[]"]');
            var name = preview.querySelector(".js-preview-name");
            var icon = preview.querySelector(".js-preview-icon");
            var duration = preview.querySelector(".js-duration");
            var error = preview.querySelector(".js-file-error");

            if (input && input.value == file.transcription_id) {
                name.innerHTML = file.name;

                if (icon.getAttribute("src") != file.icon) {
                    icon.setAttribute("src", file.icon);
                }

                if (file.status == "downloading") {
                    duration.classList.add("d-none");
                }

                if (file.error) {
                    if (this.isPromoForm) {
                        this.clear();
                    }
                    duration.classList.add("d-none");
                    error.classList.remove("d-none");
                    error.innerHTML = file.error;
                }
            }
        }
    }

    clear() {
        this.dropzone.removeAllFiles(true);
    }

    async deleteFile(transcriptionId) {
        try {
            await api.post(`api/files/multipleDelete`, {
                transcriptionIds: [transcriptionId],
            });
        } catch (error) {
            console.error("Ошибка при запросе на удаление файла:", error);
        }
    }
}
